const UK_VARIANTS = [
  "referral-reasons",
  "without-qdp-drawer",
  "unsupported-trade-referral",
  "supported-trade-referral",
];
export const variants = (variant: string | undefined) => {
  return UK_VARIANTS.includes(variant as string);
};
